import Box from "@mui/material/Box";
import { ErrorBoundary } from "react-error-boundary";

import BiodiversityListContainer from "./biodiversity-list/BiodiversityList";
import ErrorFallback from "../common/ErrorFallback";

function BiodiversityContainer() {
  return (
    <Box
      data-testid="biodiversity-container"
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <BiodiversityListContainer />
      </ErrorBoundary>
    </Box>
  );
}

export default BiodiversityContainer;
